import ServiceRestApi from "./service-rest-api";

class SupervisorService {

    getUsers = (date) => {
        return ServiceRestApi.get("/api/users");
    }
    getUser = (data) => {
        return ServiceRestApi.get("/api/user?user=" + data);
    }
    // getStatus = () => {
    //     return ServiceRestApi.get("api/user-status");
    // }


    /** Revamp ** */
    getRecapInterventionsByStatus = (params) => {
        return ServiceRestApi.get(`/api/supervision/intervention-status?${params}`);
    }
}

export default new SupervisorService();